import React from 'react'
import NewsUpper from './newsUpper'
import NewsMiddle from './newsMiddle'
import NewsLower from './newsLower'

export default function News() {
  return (
    <>
      <NewsUpper />
      <NewsMiddle />
      <NewsLower />
    </>
  )
}
